module.exports = __webpack_public_path__ + "img/interview-session.80d26481.svg";